import { Chip, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import { useMemo } from 'react'

import { useTranslation } from '@/core'
import { Cell } from '@/core/architecture'

type ThreadCategoryProps = {
  category: string
  isOfficial: boolean
  sx?: SxProps
}

export const ThreadCategory: Cell<ThreadCategoryProps> = ({
  isOfficial,
  category,
  sx,
}) => {
  const { t } = useTranslation('artistThreads')
  const label = useMemo(() => {
    if (isOfficial) {
      return t('officialCommunity')
    }
    return t([`category_${category}`, category])
  }, [isOfficial, t, category])

  const { color, bgcolor } = useMemo(() => {
    if (isOfficial) {
      return { bgcolor: 'secondary.dark', color: 'white' }
    }
    return { bgcolor: 'grey.100', color: 'text.secondary' }
  }, [isOfficial])

  return (
    <Chip
      label={
        <Typography variant="subtitle2" color={color}>
          {label}
        </Typography>
      }
      size="small"
      sx={{ bgcolor, height: 20, borderRadius: '2px', ...sx }}
    />
  )
}
